import { render, staticRenderFns } from "./Wetter.vue?vue&type=template&id=1ec58a7e&"
import script from "./Wetter.vue?vue&type=script&lang=js&"
export * from "./Wetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports